import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { translate } from '../i18n';
import useMyDocuments from '../hooks/useMyDocuments';
import { DOCUMENTS_PATH } from '../servics/accountDocumentsApi';

const DISMISS_KEY = 'documentsAlertDismissed';

const dismissed = () => {
    try {
        return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch {
        return false;
    }
};

/**
 * Rappel tant que le dossier documentaire du compte est incomplet (PENDING) ou qu'une pièce a été
 * refusée (REJECTED) : « Vos documents d'entreprise / d'identité sont toujours en attente ».
 * Masquable pour la session du navigateur ; il revient à la prochaine visite.
 */
const DocumentsPendingAlert = () => {
    const location = useLocation();
    const language = useSelector((state) => state.lang?.lang) || 'FR';
    const token = useSelector((state) => state.auth?.token) || localStorage.getItem('token');
    const [hidden, setHidden] = useState(dismissed);
    const { documents } = useMyDocuments(token, location.pathname);

    if (!documents || hidden || location.pathname === DOCUMENTS_PATH) return null;
    if (documents.status !== 'PENDING' && documents.status !== 'REJECTED') return null;

    const text = translate('account_documents', language) || translate('account_documents', 'FR');
    const profile = documents.profile === 'COMPANY' ? text.company : text.individual;
    const title = documents.status === 'REJECTED' ? text.alert_rejected_title : profile.alert_title;

    const hide = () => {
        try {
            sessionStorage.setItem(DISMISS_KEY, '1');
        } catch {
            // stockage indisponible : masqué jusqu'au rechargement
        }
        setHidden(true);
    };

    return (
        <div className="documents-pending-alert" role="status">
            <span aria-hidden="true">📄</span>
            <p>
                <strong>{title}</strong> {profile.why}
            </p>
            <Link className="button documents-pending-alert__action" to={DOCUMENTS_PATH}>
                {text.alert_action}
            </Link>
            <button type="button" className="documents-pending-alert__later" onClick={hide}>
                {text.alert_later}
            </button>
        </div>
    );
};

export default DocumentsPendingAlert;
